module.exports = __webpack_public_path__ + "static/media/ic_coleta_orange.9237dfc8.svg";